<template>
    <Navbar />
    <router-view v-slot="{ Component }">
        <transition name="fade">
            <suspense timeout="0">
                <template #default>
                    <component :is="Component" :key="$route.path" />
                    <!-- <LoadShipment /> -->
                </template>
                <template #fallback>
                    <LoadShipment />
                </template>
            </suspense>
        </transition>
    </router-view>
    <Foot />
</template>

<script setup lang="ts">
import Foot from '@/Components/Section/Foot.vue';
import Navbar from '@/Components/Section/Navbar.vue';
import LoadShipment from '@/Components/Skeleton/LoadShipment.vue';
</script>

<style>
.fade-enter-active {
    transition: opacity 1s ease;
}

.fade-leave-active {
    transition: opacity 0s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>